import {Component, h, Prop, Method, Host} from '@stencil/core';
import {TooltipVariants} from '@/types';

/**
 * @slot tooltip-content - The content that will be cloned and injected in the actual tooltip. This slot content is hidden.
 */
@Component({
    tag: 'joy-tooltip',
    styleUrl: 'tooltip.scss',
    shadow: true,
})
export class Tooltip {
    private arrow: HTMLElement | null = null;

    /** Color theme. 2 possible values */
    @Prop({reflect: true}) variant: TooltipVariants = 'primary';

    @Method()
    async getArrow(): Promise<HTMLElement> {
        return this.arrow!;
    }

    private get variantClass() {
        return {['joy-tooltip__' + this.variant]: true};
    }

    render() {
        return (
            <Host role="tooltip">
                <div
                    class={{
                        'joy-tooltip': true,
                        ...this.variantClass,
                    }}
                >
                    <div ref={(el) => (this.arrow = el as HTMLElement)} class="joy-tooltip__arrow"></div>
                    <slot name="tooltip-content" />
                </div>
            </Host>
        );
    }
}
